import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import SlidingMenu, { SlidingMenuOption } from '../general-components/sliding-menu';
import ContentFormProvider from "../../contexts/generated-content/content-form-context";
import ContentGeneratorHandler from "./settings/content-generator-handler";
import AudioSettings from './audio-settings';
import { GreenroomState } from "../../stores/types/types";
import { MEDIA_SETTINGS_TABS } from "../../stores/reducers/session"
import { TABS } from "../../stores/types/tabs";
import ThemeTab from "./stylepacks/themes/theme-tab";
import { setEditingTheme } from "../../stores/actions/themes";
import { ROOM_STATES } from '../../stores/reducers/settings';
import { setActiveSubTab } from '../../stores/actions/tabs';

const menuOptions: SlidingMenuOption[] = [
	{ label: 'Content', data: { value: MEDIA_SETTINGS_TABS.CONTENT } },
	{ label: 'Theme', data: { value: MEDIA_SETTINGS_TABS.THEME } },
	{ label: 'Audio', data: { value: MEDIA_SETTINGS_TABS.AUDIO } },
];

interface Props {
	isForShotEditorModal?: boolean;
}

export default function MediaSettings(props: Props) {
	const { isForShotEditorModal = false } = props;

	const activeSubTabs = useSelector((s: GreenroomState) => s.TabsReducer.activeSubTabs);
	const selectedMediaItem = useSelector((s: GreenroomState) => s.GeneratedContentReducer.selectedMediaItem);

	const roomState = useSelector((s: GreenroomState) => s.MeetingReducer.roomState);

	const dispatch = useDispatch();

	const initialTab = React.useMemo(() => {
		return menuOptions.find((x) => x.data.value === activeSubTabs[TABS.GENERATE_MEDIA_CONTENT]);
	}, [activeSubTabs[TABS.GENERATE_MEDIA_CONTENT]]);

	useEffect(() => {
		setCurrentTab(initialTab ?? menuOptions[0]);
		dispatch(setEditingTheme(null, false));
	}, [initialTab, selectedMediaItem?.id]);

	const filteredMenuOptions = React.useMemo(() => {
		if (roomState !== ROOM_STATES.EDITING) {
			return menuOptions.filter(option => option.data.value !== MEDIA_SETTINGS_TABS.AUDIO);
		}
		return menuOptions;
	}, [roomState]);

	const [currentTab, setCurrentTab] = useState(initialTab ?? menuOptions[0]);

	return (<>
		<SlidingMenu
			options={filteredMenuOptions}
			selectedOption={currentTab}
			callback={(o: SlidingMenuOption) => {
				setCurrentTab(o);
				dispatch(setActiveSubTab(TABS.GENERATE_MEDIA_CONTENT, o.data.value));
			}}
			className="padding-left-small position-relative width-calc-full"
			fullWidthDivider={true}
			dividerClassname='lemonade'
		/>
		{currentTab?.data?.value === MEDIA_SETTINGS_TABS.CONTENT && (
			<ContentFormProvider isForShotEditorModal={isForShotEditorModal}>
				<ContentGeneratorHandler fieldTypes={['image', 'string', 'duration']}/>
			</ContentFormProvider>
		)}
		{currentTab?.data?.value === MEDIA_SETTINGS_TABS.THEME && (
			<ContentFormProvider isForShotEditorModal={isForShotEditorModal}>
				<ThemeTab isForShotEditorModal={isForShotEditorModal}/>
			</ContentFormProvider>
		)}
		{currentTab?.data?.value === MEDIA_SETTINGS_TABS.AUDIO && (
			<AudioSettings />
		)}
	</>);
}
